export const DEFAULT_USER_IMAGE: string = '/user-default.png';
export const DEFAULT_USER_IMAGE_PATH: string = '/storage/users/default.png';
export const MAX_AVATAR_FILE_SIZE: number = 7340032;
export const MAX_PHOTO_SIZE_ERROR: string = 'Максимальный размер фото - 7 Мб';
export const AVATAR_ACCEPT_EXTENSIONS: string = '.jpg, .jpeg, .png, .webp';
export const MIN_AVATAR_IMAGE_SIZE: number = 480;
